module.exports = __webpack_public_path__ + "static/media/successGreen.4341247c.svg";